import { ApplicationStatus } from '@/apis/family_application/requests'
import Badge, { ColorType } from '@/common/components/Badge.tsx'
import { useTranslation } from 'react-i18next'

export type ApplicationStatusBadgeProps = {
  status: ApplicationStatus
  className?: string
}

export default function ApplicationStatusBadge({
  status,
  className,
}: ApplicationStatusBadgeProps) {
  const { t: translate } = useTranslation()

  let color: ColorType = 'Neutral'
  switch (status) {
    case 'Invited':
      color = 'Informative'
      break
    case 'Pending':
    case 'Appeal':
    case 'In Progress':
      color = 'Notice'
      break
    //case 'Appeal Accepted':
    case 'Eligible':
    case 'Complete':
    case 'Awarded':
      color = 'Positive'
      break
    case 'In Review':
      //case 'Appeal Denied':
      //case 'Ineligible':
      //color = 'Negative'
      break
    case "Withdrawn":
      color = "Negative"
      break
    default:
      color = 'Neutral'
  }
  return (
    <Badge semanticColor={color} className={className}>
      {translate(status.toLowerCase().replace(/ /g, '_'))}
    </Badge>
  )
}
